// ReSharper disable InconsistentNaming

import Vue from 'vue'
import VueRouter from 'vue-router'
import Lobby from '../components/Lobby.vue'
import Online from '../components/Online.vue'
import Walkin from '../components/Walkin.vue'
import WalkinSuccess from '../components/Walkin_Success.vue'
import OnlineSuccess from '../components/Online_Success.vue'
import Message from '../components/Message.vue'
import WalkinRedirect from '../components/Walkin_Redirect.vue'

Vue.use(VueRouter);

export default new VueRouter({
    routes: [
        {
            name: 'lobby_root',
            path: '/:clientId',
            component: Lobby
        },
        {
            name: 'lobby',
            path: '/lobby/:clientId',
            meta: {
                title: 'Lobby'
            },
            component: Lobby
        },
        {
            name: 'lobby_legacy',
            path: '/walkin/lobby/:clientId',
            meta: {
                title: 'Lobby'
            },
            component: Lobby
        },       
        {
            name: 'online',
            path: '/online/:clientId',
            component: Online
        },
        {
            name: 'online_success',
            path: '/online_success/:clientId',
            component: OnlineSuccess
        },
        {
            name: 'walkin',
            path: '/walkin/:clientId',
            component: Walkin
        },
        {
            name: 'walkin_legacy',
            path: '/walkin/walkin/:clientId',
            component: Walkin
        },
        {
            name: 'walkin_success',
            path: '/walkin_success/:clientId',
            component: WalkinSuccess
        },
        {
            name: 'message',
            path: '/message/:clientId',
            component: Message
        },
        {
            name: 'walkin_redirect',
            path: '/walkin_redirect_message/:clientId',
            component: WalkinRedirect
        },
        {
            name: 'api_ignore',
            path: '/api/*'
        },
        {
            name: 'api_ignore2',
            path: '/api'
        },
        {
            name: 'api_ignore3',
            path: '*'
        }
    ]
})